import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';

var dependencies = {}; // eslint-disable-next-line zillow/import/prefer-default-export

function useDependency(_ref) {
  var name = _ref.name,
      verifyRequired = _ref.verifyRequired,
      loadDependency = _ref.loadDependency;
  var required = !verifyRequired || verifyRequired(typeof window !== 'undefined' ? window : undefined);

  var _useState = useState(!required),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  if (typeof loadDependency !== 'function') {
    throw new Error('loadDependency is required and must be a function.');
  }

  if (!required) {
    // Short circuit when it's not needed.
    return [true, undefined];
  }

  var promise = dependencies[name];

  if (!promise) {
    promise = loadDependency();
    promise.loaded = false;
    dependencies[name] = promise;
    promise.then(function (r) {
      var dependency = dependencies[name];
      dependency.resource = r;
      dependency.loaded = true;
    });
  }

  if (!loaded) {
    promise.then(function () {
      setLoaded(true);
    });
  }

  return [loaded || promise.loaded, promise.resource, required];
} // istanbul ignore else

if (process.env.NODE_ENV === 'test') {
  Object.defineProperty(useDependency, 'testDependencies', {
    value: dependencies
  });
}

export { useDependency };
